import { useNavigate } from 'react-router-dom';
import { useGetMyToken, useGetProfile } from '../Myprofile/api';
import { t } from 'i18next';

const MyToken = (props) => {
    const navigate = useNavigate()
    const { data: getProfile,isLoading:getProfileLoading } = useGetProfile()
    const { data: myToken } = useGetMyToken()

    const USDAmount =getProfile?.balance?.currencyBalance * myToken?.data?.KKOG_Details?.usd_price
    const totalContribution=myToken?.data?.totalPurchaseToken * myToken?.data?.KKOG_Details?.usd_price
    const bounsAmount=myToken?.data?.totalbonusToken
    const ReferralSupply=myToken?.data?.reward_Spend

    return (
        <div className="MytknPg">
            <div className="row CustRw">
                <div className="col-lg-8 CustPad">
                    <div className="MyTknBg">
                        <div className="MyTknBgTp">
                            <h4>{t('My KKOG Token')}</h4>
                        </div>
                        <div className="MyTknDts">
                            <div className="Ldv">
                                <label>{t('Total Balance')}</label>
                                <h4>{getProfileLoading ? '' :parseFloat(getProfile?.balance?.currencyBalance).toFixed(8)} KKOG</h4>
                                <h6>{t('Equivalent to')} {!USDAmount ? 0 : parseFloat(USDAmount).toFixed(2)} USD</h6>
                            </div>
                            <button className="btn CmnBtn px-4" onClick={() => navigate('/buytoken')}>{t('Buy KKOG COIN')}<img src={require('../../assets/images/cart.gif')} alt='' width="23px" className='ml-2' /></button>
                        </div>
                        <div className='MyTknDtsLst'>
                            <div className='Ldv'>
                                <label>{t('Purchased Token')}</label>
                                <h4>{myToken?.data?.totalPurchaseToken} KKOG</h4>
                            </div>
                            <div className='Ldv'>
                                <label>{t('Referral Token')}</label>
                                <h4>{myToken?.data?.totalreferalToken} KKOG</h4>
                            </div>
                            <div className='Ldv'>
                                <label>{t('Upline Commission')}</label>
                                <h4>{ReferralSupply} KKOG</h4>
                            </div>
                            <div className='Ldv'>
                                <label>{t('Bonus Token')}</label>
                                <h4>{!bounsAmount ? 0 : parseFloat(bounsAmount).toFixed(2)} KKOG</h4>
                            </div>
                        </div>
                        <div className="MyTknDts">
                            <div className="Ldv">
                                <label>{t('Total Contribution')}</label>
                                <h4>{!totalContribution ? 0 : parseFloat(totalContribution).toFixed(2)} USD</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 CustPad">
                    <div className='DshbrdPrfl'>
                        <div className='DshbrdPrflTp'>
                            <h4>{t('Welcome')} <span>{getProfile?.data?.userName}</span></h4>
                        </div>
                        <div className='DshbrdPrflVrfy'>
                            <label>{t('Your Account Status')}</label>
                            <h5>{t('Email Verified')}<img src={require('../../assets/images/tick-circle.svg').default} alt='' /></h5>
                            <div className='mt-2'>
                                <label>{t('Receiving Wallet')}</label>
                                <p>{getProfile?.data?.walletAddress}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default MyToken;